/** Whether a request URL is the Tardek logout request. Its own requests must not trigger another
 *  logout — neither through the expiry check nor through a 401. */
export default function isLogoutUrl(url: string | undefined): boolean {
  return url?.endsWith('/auth/logout') ?? false
}
